import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { AngularGridInstance, Column, FileType, GridOption } from 'angular-slickgrid';
import { VinsBuquesService } from 'src/app/servicios/vins-buques.service';
import { SnackBarComponent } from 'src/app/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
//import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';


import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-vins-buques-delete-or-dismiss',
    templateUrl: './vins-buques-delete-or-dismiss.component.html',
    styleUrls: ['./vins-buques-delete-or-dismiss.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, 
      NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, 
      MatInputModule, AngularSlickgridModule, NbTabsetModule,
       MatDatepickerModule, MatNativeDateModule, NbSelectModule, 
       NbTreeGridModule, MultiSelectModule,
      AgGridAngular],
})
export class VinsBuquesDeleteOrDismissComponent implements OnInit {

  constructor(protected dialogRef: NbDialogRef<VinsBuquesDeleteOrDismissComponent>, private svcVinsBuq: VinsBuquesService, private _snackBar: MatSnackBar) { }
  @Input('dialogData') dialogData: any;
  @Input('visita') visita: any;
  // @Input('title') title: any;
  @ViewChild('grilla1') grilla1!: AgGridAngular;

  durationInSeconds = 3;

  dataVinsDelete: any = [];
  angularGridVinsDelete: AngularGridInstance;
  columnDefinitionsVinsDelete: ColDef[];
  gridOptionsVinsDelete: GridOption;
  gridObjVinsDelete: any;
  filaSeleccionadas;
  cntSeleccionadas = 0;
  totalReg;

  ngOnInit(): void {
    this.ingresarDatosGrillaToDLT()
  }

  ingresarDatosGrillaToDLT(){
    this.columnDefinitionsVinsDelete = [
        {
          headerName: '',               // sin título
          checkboxSelection: true,      // checkbox por fila
          headerCheckboxSelection: true, // checkbox en header para seleccionar todo
          width: 50,                     // ancho chico
          pinned: 'left'                 // opcional: fija la columna a la izquierda
        },
      { //id: 'VIN', 
        headerName: 'VIN', field: 'VIN', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'OrigenDestino', 
        headerName: 'Origen/Destino', field: 'OrigenDestino', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'nfactura', 
        headerName: 'Factura', field: 'nfactura', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60, },
      { //id: 'bl', 
        headerName: 'BL', field: 'bl', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60, },
    ];
    this.gridOptionsVinsDelete = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: true,
      enableRowSelection: true,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
    this.dataVinsDelete =  this.insertarDataGrilla(this.dialogData)
    this.totalReg = this.dataVinsDelete.length
  }

  insertarDataGrilla(arrVins){
    let _vins: Array<any> = [];
    for (let i = 0; i < arrVins.length; i++) {
      _vins.push(
        { 
          id: i, 
          VIN: arrVins[i].vin, 
          OrigenDestino: arrVins[i].destinoOrigen, 
          nfactura: arrVins[i].numeroFactura, 
          bl: arrVins[i].bl, 
          idVisitaDetalle: arrVins[i].idVisitaDetalle}
      )
    }
    return _vins
  }

  onSelectedRowsChanged(e, args) {
    if (Array.isArray(args.rows)) {
      this.filaSeleccionadas = args.rows.map(idx => {
        const item = this.gridObjVinsDelete.getDataItem(idx);
        return item;
      });
      this.cntSeleccionadas = this.filaSeleccionadas.length;
    }
  }

  eliminarSeleccion(){
    let _arrToDLT = [];
    this.filaSeleccionadas.forEach(row =>{_arrToDLT.push(row.idVisitaDetalle)});

    let objData = {
      idVisita: this.visita,
      idVisitaDetalle: _arrToDLT
    }

    this.svcVinsBuq.deleteVinsVisita(objData).subscribe( data =>{
      if (data["status"] == 200){
        this.openSnackBar("Se eliminaron los registros correctamente.")
        this.closeDialog(1);
      }else{
        this.openSnackBar("Ha ocurrido un error interno.")
        this.closeDialog(0);
      }
    })
  }

  angularGridReadyVinsDelete(angularGrid: AngularGridInstance){
    this.angularGridVinsDelete = angularGrid;
    this.angularGridVinsDelete.resizerService.pauseResizer(false)
    this.gridObjVinsDelete = angularGrid && angularGrid.slickGrid || {};
  }

  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  closeDialog(value = 0) {
    this.dialogRef.close({closedBy: value});
  }

  onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
  
  }

  onSelectionChanged(event: any) {
  this.filaSeleccionadas = event.api.getSelectedRows();
  console.log('VINS seleccionados:', this.filaSeleccionadas);
}

}
